var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"py-10",attrs:{"align":_vm.alignMiddle ? 'center' : 'start',"justify":"center","row":""}},[_c('v-progress-circular',{attrs:{"size":70,"width":3,"color":"primary","indeterminate":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }